import { Box } from "@mui/material";
import React from "react";

const DateAndTimeViewer = ({ dateAndTime }) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: "5px",
        fontSize: {
          md: "10px !important",
          lg: "12px !important",
          xl: "12px !important",
        },
      }}
    >
      <span>
        {new Intl.DateTimeFormat("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }).format(new Date(dateAndTime))}
      </span>
      <span>|</span>
      <span>
        {new Intl.DateTimeFormat("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        }).format(new Date(dateAndTime))}
      </span>
    </Box>
  );
};

export default DateAndTimeViewer;
